module.exports = __webpack_public_path__ + "assets/img/782a95d782e5041c3b5135b71e9b09a3.jpg";